<template>
  <div class="service-width">
    <div v-show="loading">
      <div>
        <p class="menuPageTitle">포인트 판매 설정</p>
        <p class="menuPageSubTitle">
          쇼핑몰 회원들에게 포인트를 판매하여 쇼핑몰 구매율을 높일 수 있습니다.
        </p>
        <p class="menuPageSubTitle">
          포인트 혜택을 지급하여 고객들이 더 많은 주문을 할 수 있게
          제공해보세요.
        </p>
      </div>

      <div>
        <CreatePointProduct ref="CreatePointProduct"></CreatePointProduct>
      </div>
      <div>
        <DisplaySetting ref="DisplaySetting"></DisplaySetting>
      </div>
    </div>
    <PageLoadingProgress ref="PageLoadingProgress"></PageLoadingProgress>
  </div>
</template>
<script>
import CreatePointProduct from "@/components/mileage/sales/component/CreatePointProduct.vue";
import DisplaySetting from "@/components/mileage/sales/component/DisplaySetting.vue";
import PageLoadingProgress from "@/components/common/PageLoadingProgress.vue";

export default {
  data: () => {
    return {
      loading: false,
    };
  },
  methods: {
    loadCompleted: function() {
      this.$refs.PageLoadingProgress.hide();
      this.loading = true;
    },
  },
  components: {
    CreatePointProduct,
    DisplaySetting,
    PageLoadingProgress,
  },
  mounted: async function() {
    this.$refs.PageLoadingProgress.show();
  },
};
</script>
